export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11852.0a252592.jpg";